/** Guest contact fields we can derive a display name from. */
export interface GuestDisplayNameSource {
  name?: string;
  email?: string;
  phone?: string;
}

/**
 * Resolve a non-empty display name for a guest when the name field may be
 * optional/blank: prefer the typed name, then the email local part, then the
 * phone, then a fallback. Used so an optional-but-empty name still yields a
 * usable display name at submit time.
 */
export const resolveGuestDisplayName = (form: GuestDisplayNameSource, fallback = 'Guest'): string => {
  const name = (form.name ?? '').trim();
  if (name) {
    return name;
  }

  const email = (form.email ?? '').trim();
  if (email) {
    const localPart = email.split('@')[0];
    if (localPart) {
      return localPart;
    }
  }

  const phone = (form.phone ?? '').trim();
  if (phone) {
    return phone;
  }

  return fallback;
};
